import Model from './Model'

export default class Webinar extends Model {

	static entity = 'webinar'
	static endpoint = 'https://studysync-www-api-v2.herokuapp.com/v1/webinars'

	static fields () {
		return {
			id: this.attr(),
			title: this.string(''),
			url: this.string(''),
			startTime: this.string(),
			endTime: this.string(),
			agenda: this.string(),
			category: this.attr()
		}
	}

}



// WEBPACK FOOTER //
// ./src/store/models/Webinar.js